import React, { useEffect, useState } from "react";
import trivvyLogo from "../../../assets/trivvy/trivvy-logo-img.png";
import "./media-link.css";

// Bug923/Bug930: pieces shared by the hashtag audio (/a/:code) and video
// (/v/:code) link pages.

// Only https S3 URLs are followed or played (defense in depth; the BE builds them itself).
export const isSignedS3Url = (value) => {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "https:" && /\.amazonaws\.com$/i.test(parsed.hostname);
  } catch (e) {
    return false;
  }
};

// A format the browser can't play would download silently and leave the page
// spinning, so those get a Download button instead. The type comes from the
// signed URL's response-content-type; when it's missing we assume it plays.
// mediaElement is "audio" or "video".
export const canBrowserPlay = (mediaUrl, mediaElement) => {
  try {
    const contentType = new URL(mediaUrl).searchParams.get("response-content-type");
    if (!contentType) return true;
    return document.createElement(mediaElement).canPlayType(contentType) !== "";
  } catch (e) {
    return true;
  }
};

// public/index.html shows a full-page "Loading..." until window.onload, which a
// loading <audio>/<video> (or the video page's playback probe) holds back. These
// pages draw their own loading card, so hide that global loader as soon as one shows.
const hideGlobalPageLoader = () => {
  const loader = document.getElementById("page-loading");
  if (loader) loader.style.display = "none";
};

export const MediaLinkCard = ({ icon, muted, title, text, children }) => {
  useEffect(() => {
    hideGlobalPageLoader();
  }, []);

  return (
    <div className="media_link_page">
      <div className="media_link_card">
        <img src={trivvyLogo} alt="Trivvy" className="media_link_logo" />
        <div>
          <span className={"media_link_icon" + (muted ? " media_link_icon_muted" : "")}>{icon}</span>
        </div>
        <h1 className="media_link_title">{title}</h1>
        {text ? <p className="media_link_text">{text}</p> : null}
        {children}
      </div>
    </div>
  );
};

// Download link with a short fading "Download started" note. The browser doesn't
// report when the file finishes saving, so the click only confirms it started.
export const DownloadWithNote = ({ href, className, children }) => {
  // 0 = hidden. Each click gets a new key, so the fade restarts even if the note is still showing.
  const [noteKey, setNoteKey] = useState(0);

  return (
    <div>
      <a href={href} download className={className} onClick={() => setNoteKey((key) => key + 1)}>
        {children}
      </a>
      {noteKey ? (
        <p key={noteKey} className="media_link_download_note" onAnimationEnd={() => setNoteKey(0)}>
          Download started. Check your downloads.
        </p>
      ) : null}
    </div>
  );
};
